export const LOCAL_API_URL = 'http://localhost:13980/api-';
export const WOD_EMPLOYEES_URL = 'https://employees-wod.ventionteams.com';

export const PROD_API_URL = 'https://mg.ventionteams.com/api-';
export const STAGING_API_URL = 'http://demo.ventionteams.com:11980/api-';
export const TESTING_API_URL = 'http://demo.ventionteams.com:13380/api-';

export const PROD_AUTH_API_URL = 'https://auth.ventionteams.com/';
export const STAGING_AUTH_API_URL = 'https://staging-auth.ventionteams.com/';
export const TESTING_AUTH_API_URL = 'https://dev-wod.ventionteams.com:5500/';
export const LOCAL_AUTH_API_URL = 'https://dev-wod.ventionteams.com:5500/';

export const TEST_AUTH_URL = `${TESTING_API_URL}auth`;

export const LOCAL_CLIENT_ID = 'vention_mg_localhost';
export const TESTING_CLIENT_ID = 'vention_mg_testing';
export const STAGING_CLIENT_ID = 'vention_mg_staging';
export const PROD_CLIENT_ID = 'vention_mg';
